/**
 * OWLY CRM - No Calificados Leads Data
 * Leads con scoring.total < 70 y stage <= 3
 */

import { Lead } from '@/types';
import { mockProjects, getUnitDisplay } from '../../projects';

const ciudadJardinUnits = mockProjects[2].units;

export const noCalificadosLeads: Lead[] = [];
